/**
 * description:
 * author: 1580043700@qq.com
 * create_date: 2023/11/14-15:54
 */

const config = {
  listTitle: ' ',
  rowSelection: false,
  fieldControl: false,
  toolbar: false,
  columns: [
    {
      title: '序号',
      dataIndex: 'indexOrder',
      width: 100,
    },
    {
      title: '文件名称',
      dataIndex: 'taskName',
      ellipsis: true,
      width: 340,
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      itemType: 'dateTime',
      width: 240,
    },
    {
      title: '状态',
      dataIndex: 'taskStatus',
      width: 180,
      render: 'statusRender',
    },
    {
      title: '操作',
      dataIndex: 'actionTool',
      width: 260,
      render: 'actionTool',
    },
  ],
  search: [
    {
      name: 'taskName',
      label: '任务名称',
      itemType: 'input',
    },
    {
      name: 'taskState',
      label: '状态',
      itemType: 'select',
      data: 'booleanOptions',
      key: 'key',
      labelKey: 'label',
    },
  ],
}
export default config
